<app-service-detail>
    <div class="row w-100 m-0 position-relative">
        <app-variables-tabs primarySelectedTab="Tables" class="container-fluid px-5">
        </app-variables-tabs>
        <app-list-grid *ngIf="!hideList"
                       class="col-md-12 px-md-5 ml-auto"
                       [items]="notificationList"
                       [baseUrl]="baseUrl"
                       [toggleIcons]="false"
                       [navigationEdit]="false"
                       [expanded]="true"
                       (deleteFunction)="deleteNotification($event)"
                       (updateFunction)="saveDeterminant($event)"
                       (editFunction)="loadNotification($event)"
                       (sortFunction)="sortNotification($event)"
                       nameFieldKey="content"
                       headingText="Guide messages available in the service"
                       createNewText1Part="Select an existing guide message or click on"
                       createNewText2Part="to create a new">
            <a (click)="loadNotification(false)"
               placement="left"
               aria-hidden="true"
               class="btn list-search-add">{{ 'Add' | translate }}</a>
        </app-list-grid>

        <div *ngIf="showEdit || showAdd"
             class="layer half-layer col px-3"
             [ngStyle]="style"
             mwlResizable
             [enableGhostResize]="true"
             [resizeEdges]="{ bottom: false, right: false, top: false, left: true }"
             (resizeEnd)="onResizeEnd($event)"
             style="min-height:calc(100vh - 9.1rem);">
            <description-notification [serviceId]="serviceId"
                                      [notification]="notification"
                                      (formSubmit)="closeSlider()"
                                      (editCancel)="closeLayers()"
                                      class="w-100"></description-notification>
        </div>
        <div class="shadow"></div>
        <div class="col">
            <tab-menu *ngIf="hideList"
                      [items]="notificationList"
                      [baseUrl]="baseUrl"></tab-menu>
            <ng-content></ng-content>
        </div>
    </div>
</app-service-detail>
